import React from 'react';
import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';

export default function BackDrop(props) {
  const loaderStatus =  useSelector((state)=> state.commonReducer.showLoader);
  
  return (
    <div>
      <Backdrop
        className='backDropColor'
        open={loaderStatus}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}